import React, { useMemo } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"

import avgResolvingImg from "assets/images/cards/disputes/avgResolving.png"
import pendingDisputesImg from "assets/images/cards/disputes/pendingDisputes.png"
import resolvedImg from "assets/images/cards/disputes/resolved.png"
import totalDisputesImg from "assets/images/cards/disputes/toalDisputes.png"


export const DisputesCards = () => {
  const { t } = useTranslation()

  const reports: { title: string; total: number | string; img: string }[] = useMemo(() => {
    return [
      {
        title: t("disputes_totalDisputes"),
        total: 15,
        img: totalDisputesImg,
      },
      {
        title: t("disputes_pendingDisputes"),
        total: 8,
        img: pendingDisputesImg,
      },
      {
        title: t("common_resolved"),
        total: 7,
        img: resolvedImg,
      },
      {
        title: t("disputes_avgResolving"),
        total: "Day 3",
        img: avgResolvingImg,
      },
    ]
  }, [t])

  return (
    <Row className="mt-3">
      {reports.map((report, key) => (
        <Col sm="6" md="4" lg="3" key={"_col_" + key}>
          <Card className="mini-stats-wid">
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <p className="text-muted fw-medium">{report.title}</p>
                  <h4 className="mb-0">{report.total}</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                  <span className="avatar-title rounded-circle bg-primary">
                    <img src={report.img} alt={report.title} className="img-fluid" />
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}
